var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5866 2.5H6.41326C6.13992 2.5 5.91992 2.27333 5.91992 2C5.91992 1.72667 6.14659 1.5 6.41992 1.5H12.5866C12.8599 1.5 13.0866 1.72667 13.0866 2C13.0866 2.27333 12.8599 2.5 12.5866 2.5Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58691 14.5H3.41357C3.14024 14.5 2.91357 14.2733 2.91357 14C2.91357 13.7267 3.14024 13.5 3.41357 13.5H9.58024C9.85357 13.5 10.0802 13.7267 10.0802 14C10.0802 14.2733 9.86024 14.5 9.58691 14.5Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4999 14.4994C6.4599 14.4994 6.4199 14.4927 6.3799 14.4861C6.11324 14.4194 5.94657 14.1461 6.01324 13.8794L9.01324 1.87941C9.0799 1.61275 9.34657 1.44608 9.6199 1.51275C9.88657 1.57941 10.0532 1.85275 9.98657 2.11941L6.98657 14.1194C6.92657 14.3461 6.72657 14.4994 6.4999 14.4994Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextItalic);
export default __webpack_public_path__ + "static/media/text-italic.394d662b.svg";
export { ForwardRef as ReactComponent };